import { useEffect, useState } from 'react';
import { useTenantPermissions } from '@maxtropy/components';
import { isNil } from 'lodash-es';

export const useQuery = <T>(action: () => Promise<T | undefined>) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<T | undefined>(undefined);
  useEffect(() => {
    setIsLoading(true);
    action()
      .then(setData)
      .finally(() => setIsLoading(false));
  }, [action]);
  return { isLoading, data };
};

export const customFixed = (value: number | string | null | undefined, fixed = 2, isPercent = false) => {
  if (isNil(value)) return '--';
  if (isNaN(Number(value))) return '--';
  if (isPercent) return Number(Number(value) * 100).toFixed(fixed);
  return Number(Number(value).toFixed(fixed));
};

export const keepTwoUndefined = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return undefined;
  }
};

export function useHasPermission(key: string) {
  const [status, setStatus] = useState<boolean>();
  const permissions = useTenantPermissions();
  useEffect(() => {
    setStatus((permissions ?? []).findIndex(i => i === key) !== -1);
  }, [permissions, key]);
  return status;
}

export const keepZeroOrLine = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(0);
  } else {
    return '--';
  }
};
